export default "__VITE_ASSET__D6tmt$cS__"